export default __webpack_public_path__ + "static/race-desktop-74b8934adfbf0d4362557107430b4630.webm";